var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "widget-container" }, [
        _c(
          "div",
          {
            staticClass: "tool",
            class: _vm.drawPolygon ? "active" : "",
            attrs: { title: "Draw Polygon", id: "polygonWidget" },
            on: { click: _vm.toggleSnippingTool },
          },
          [
            _c("fa", {
              staticClass: "icon",
              attrs: { icon: ["fas", "crop"], size: "1x" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "tool",
            class: { active: _vm.polygonActive },
            attrs: { title: "Upload Polygon", id: "uploadWidget" },
            on: { click: _vm.initModal },
          },
          [
            _c("fa", {
              staticClass: "icon",
              attrs: { icon: ["fas", "cloud-upload-alt"], size: "1x" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "tool",
            class: { active: _vm.baseMapActive },
            attrs: { id: "base-maps", title: "Toggle Base Map" },
            on: { click: _vm.selectNewBase },
          },
          [
            _c("fa", {
              staticClass: "icon",
              attrs: { icon: ["fas", "map"], size: "1x" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "tool",
            class: { active: _vm.measuringToolOn },
            attrs: { title: "Measuring Tool" },
            on: { click: _vm.toggleMeasure },
          },
          [
            _c("fa", {
              staticClass: "icon",
              attrs: { icon: ["fas", "ruler"], size: "1x" },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "polygonInputModal",
            size: "md",
            centered: "",
            "hide-header-close": "",
            "dialog-class": "polygonInput-modal-dialog",
            "content-class": "polygonInput-modal-content",
            "modal-header-class": "polygonInput-modal-header",
          },
          on: {
            show: function ($event) {
              return _vm.reset()
            },
          },
          scopedSlots: _vm._u([
            {
              key: "modal-header",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass:
                        "polygonInput-header d-flex align-items-center w-100",
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "polygonInput-header-icon" },
                        [
                          _c("fa", {
                            attrs: { icon: ["fas", "draw-polygon"] },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "polygonInput-header-text" }, [
                        _c("h5", { staticClass: "polygonInput-title mb-0" }, [
                          _vm._v("Upload Geometry"),
                        ]),
                        _vm._v(" "),
                        _c("small", { staticClass: "polygonInput-subtitle" }, [
                          _vm._v(
                            "Paste a WKT string or import a KML / KMZ file"
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "modal-footer",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "polygonInput-footer" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "close-btn",
                          on: {
                            click: function ($event) {
                              return _vm.closePolygonInputModal()
                            },
                          },
                        },
                        [_vm._v("\n          Cancel\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "submit-btn",
                          attrs: {
                            id: "uploadSampleBtn",
                            disabled:
                              !_vm.isValid ||
                              (_vm.loadingText && _vm.polygonInput == "") ||
                              (_vm.loadingFile && !_vm.selectedFile) ||
                              !_vm.currentExtent,
                          },
                          on: { click: _vm.renderPolygon },
                        },
                        [
                          _c("fa", {
                            staticClass: "mr-2",
                            attrs: { icon: ["fas", "cloud-upload-alt"] },
                          }),
                          _vm._v("\n          Upload\n        "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _vm.loadingText || _vm.loadingFile
            ? _c(
                "div",
                { staticClass: "modal-overlay" },
                [
                  _c("b-spinner", {
                    staticClass: "spinner-lg",
                    attrs: { label: "Loading...", variant: "light" },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-tabs",
            {
              staticClass: "polygonInput-tabs",
              attrs: {
                card: "",
                "nav-class": "polygonInput-tabs-nav",
                "active-nav-item-class": "active-tab",
              },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c("b-tab", { attrs: { title: "WKT Upload" } }, [
                _c("div", { staticClass: "tab-pane-wrapper" }, [
                  _c(
                    "div",
                    { staticClass: "tab-content-inner" },
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "form-block" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "field-label",
                              attrs: { for: "wktTextarea" },
                            },
                            [_vm._v("WKT geometry")]
                          ),
                          _vm._v(" "),
                          _c("b-form-textarea", {
                            ref: "wktTextarea",
                            staticClass: "wkt-textarea",
                            attrs: {
                              placeholder:
                                "e.g. POLYGON ((-122.68 45.51, -122.68 45.52, ...))",
                              id: "wktTextarea",
                            },
                            on: { input: _vm.resizeTextarea },
                            model: {
                              value: _vm.polygonInput,
                              callback: function ($$v) {
                                _vm.polygonInput = $$v
                              },
                              expression: "polygonInput",
                            },
                          }),
                          _vm._v(" "),
                          _c("small", { staticClass: "field-hint" }, [
                            _vm._v(
                              "Coordinates should be in longitude / latitude (EPSG:4326)."
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("b-tab", { attrs: { title: "KML / KMZ Upload" } }, [
                _c("div", { staticClass: "tab-pane-wrapper" }, [
                  _c(
                    "div",
                    { staticClass: "tab-content-inner fileUploadControl" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "form-block",
                          attrs: { id: "polygonShapeFile" },
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "field-label",
                              attrs: { for: "polygonFileSelect" },
                            },
                            [_vm._v("Geometry file")]
                          ),
                          _vm._v(" "),
                          _c("b-form-file", {
                            ref: "refPolygonShapeFile",
                            attrs: {
                              id: "polygonFileSelect",
                              accept: ".kml,.kmz",
                              placeholder: "Select a file or drag it here...",
                              "drop-placeholder": "Drop file here...",
                            },
                            on: { input: _vm.handleFileUpload },
                            scopedSlots: _vm._u([
                              {
                                key: "button-content",
                                fn: function () {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "cursor" },
                                      [
                                        _vm._v(
                                          "\n                    Browse\n                    "
                                        ),
                                        _vm.loadingFile
                                          ? _c("b-spinner", {
                                              staticClass: "mr-2",
                                              attrs: { small: "" },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.selectedFile,
                              callback: function ($$v) {
                                _vm.selectedFile = $$v
                              },
                              expression: "selectedFile",
                            },
                          }),
                          _vm._v(" "),
                          _c("small", { staticClass: "field-hint" }, [
                            _vm._v("Accepted formats: .kml, .kmz"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.selectedFile
                        ? _c(
                            "div",
                            { staticClass: "selected-file" },
                            [
                              _c("fa", {
                                staticClass: "selected-file-icon",
                                attrs: { icon: ["fas", "file-alt"] },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "selected-file-name" },
                                [_vm._v(_vm._s(_vm.selectedFile.name))]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }